export default {
    "Decentralization":"Decentralization ",
    "Coin-based":"Coin-based ",
    "Perpetual Options":"Perpetual Options",
    "Future Derivatives Infrastructure":"Future Derivatives Infrastructure",
    "Start Trading":"Start Trading",
    "Trading":"Trading",
    "Follow":"Copy Trading",
    "Fund Pool":"Fund Pool",
    "Recommendation Reward":"Recommendation Reward",
    "Language":"Language",
    "Never Liquidate":"Never Liquidate",
    "Eliminate Liquidation Risk":"Eliminate Liquidation Risk",
    "Risk Management Easier":"Risk Management Easier",
    "High Leverage":"High Leverage",
    "Multiple Leverage":"Multiple Leverage",
    "High Profit Potential":"High Profit Potential",
    "Zero Slippage":"Zero Slippage",
    "Execution Price Meets Expected Results":"Execution Price Meets Expected Results",
    "Eliminate Impermanent Loss":"Eliminate Impermanent Loss",
    "Commission Rate 15%":"50% Commission",
    "Generous recommendation rewards, recognize your contribution":"Generous recommendation rewards, recognize your contribution",
    "Generous recommendation rewards, recognize your contribution2":"Generous recommendation rewards<br/>recognize your contribution",
    "Invite a friend":"Invite a friend",
    "Invite a friend to Fufuture via a referral link":"Invite a friend to Fufuture via a referral link",
    "Friend completes first order":"Friend completes first order",
    "Friend accepts invitation and completes first order":"Friend accepts invitation and completes first order",
    "Get your commission":"Get your commission",
    "Get your commission immediately and claim it anytime":"Get your commission immediately and claim it anytime",
    "Create my link":"Create my link",
    "Deep liquidity supported by dual pools":"Deep liquidity supported by dual pools",
    "Public pool":"Public pool",
    "Available liquidity":"Available liquidity",
    "Private pool":"Private pool",
    "Add LP":"Add LP",
    "FAQ":"FAQ",
    "Future Derivatives Infrastructure2":"Future Derivatives Infrastructure",
    "Dual liquidity pool":"Dual liquidity pool",
    "Open liquidity pool":"Open liquidity pool",
    "More stable liquidity":"More stable liquidity",
    "Reasonable pricing":"Reasonable pricing",
    "Price feed from third-party oracle":"Price feed from third-party oracle",
    "Precise error control":"Precise error control",
    "BTC 24-hour trading volume summary":"BTC 24h trading volume",
    "BTC holdings summary":"BTC holdings",
    "ETH 24-hour trading volume summary":"ETH 24h trading volume",
    "ETH holdings summary":"ETH holdings",
    "q1":"How do I enhance my account security?",
    "a1":"Enter the trading website through the wallet, protect your personal private key, do not click on phishing links and scan unknown QR codes.",
    "q2":"How do I deposit?",
    "a2":"Select the public chain where the target token is located in Fufuture, and select the target token for deposit operation.",
    "q3":"What is the transaction fee on Fufuture?",
    "a3":"Perpetual options only charge 1‰ when opening a position."
}
